import React from 'react';
import ReaderDetail from './components/ReaderDetail';

const ReaderDetailPage: React.FC = () => {
  // Title is set at the application level
  return <ReaderDetail />;
};

export default ReaderDetailPage;